import { userRoleSchema, UserRole } from "../domain/entities";

export function extractRoleFromToken(token: string): UserRole | null {
  try {
    const parts = token.split(".");
    if (parts.length < 2) return null;
    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const json = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join(""),
    );
    const parsed = JSON.parse(json);
    const parsedRole = userRoleSchema.safeParse(parsed.role);
    if (parsedRole.success) {
      return parsedRole.data;
    }
    return null;
  } catch {
    return null;
  }
}
